import * as React from 'react';
import type { SVGProps } from 'react';

const SvgGiftboxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none" {...props}>
    <path fill="#fff" d="M20.5 12v10h-16V12" />
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 12v10h-16V12"
    />
    <path
      fill="#fff"
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22.5 7h-20v5h20V7Z"
    />
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.5 22V7"
    />
    <path
      fill="#fff"
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.5 7H8a2.5 2.5 0 1 1 0-5c3.5 0 4.5 5 4.5 5ZM12.5 7H17a2.5 2.5 0 0 0 0-5c-3.5 0-4.5 5-4.5 5Z"
    />
  </svg>
);
export default SvgGiftboxIcon;
